export const EventSummarySearchState = {
  errorMessage: '',
  isLoading: false,
  results: [],
};
